module.exports = __webpack_public_path__ + "static/work56-485a882802b70903d98e978ecb69493e.jpg";